<template>
  <div class="mod-web-header">
    <div class="mod-header">
      <div class="mod-box clearfix">
        <a href="/"><img class="logo" src="../assets/images/logo.png" /></a>
        <h4 class="title">{{ title }}</h4>
        <p v-if="status === 0" class="status">
          我还未注册，现在去&ensp;<a href="/register">注 册</a>
        </p>
        <p v-else-if="status === 1" class="status">
          我已经注册，现在去&ensp;<a href="/login">登 录</a>
        </p>
        <div v-else class="user">
          <router-link to="/">商城首页</router-link>
          <span><i class="icon" />{{ user.username }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUser } from '@/utils'

export default {
  name: 'ModWebHeader',
  props: {
    status: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      user: getUser() || {}
    }
  }
}
</script>

<style lang="postcss">
.mod-web-header {
  background-color: #fabe00;
  height: 88px;
  padding-top: 12px;

  .logo {
    float: left;
    width: 130px;
  }

  .title {
    font-size: 18px;
    font-weight: normal;
    float: left;
    margin: 8px 0 0 25px;
    padding: 11px 0 11px 25px;
    line-height: 24px;
    border-left: 1px solid #666;
  }

  .status {
    float: right;
    line-height: 40px;
    margin-top: 36px;

    a {
      font-weight: bold;
    }
  }

  .user {
    color: #fff;
    float: right;
    line-height: 62px;

    a {
      color: #fff;
      margin-right: 15px;
      text-decoration: underline;
    }

    span {
      text-decoration: underline;
    }

    .icon {
      display: inline-block;
      width: 23px;
      height: 23px;
      background: url(../assets/images/icon-menu.png) no-repeat -54px 0;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>
